var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState } from "react";
import EmandateInfoPage from "../Mandate/EmandateInfoPage";
import "@frameworks/shared-library/stylesheets/components/TransactionJourney/TxnOrderStatus/OrderStatusScreen.scss";
import GenericDetails from "@frameworks/shared-library/components/GenericDetails/GenericDetails";
var OrderStatusScreen = function (_a) {
    var genericDetails = _a.genericDetails, genericDetailsCollapse = _a.genericDetailsCollapse, icon = _a.icon, title = _a.title, description = _a.description, children = _a.children, hideHeader = _a.hideHeader, callbackOnContainerClick = _a.callbackOnContainerClick, subDescription = _a.subDescription;
    var _b = __read(useState(false), 2), isCollapse = _b[0], setIsCollapse = _b[1];
    var handleDivOnClickShowMandateDetails = function () {
        setIsCollapse(!isCollapse);
    };
    return (React.createElement("div", { className: "parent-order-info-container commonscroll", onClick: function () { return callbackOnContainerClick && callbackOnContainerClick(); } },
        React.createElement("main", { className: "d-flex flex-column align-items-center status-container" },
            !hideHeader && (React.createElement("p", { className: "DMSansNormal_20_400 align-self-start mb-30" }, "Order Confirmation")),
            React.createElement("div", { className: "d-flex flex-column align-items-center w-100 ".concat(hideHeader ? "mgt-100" : "gap-2 ") },
                React.createElement(EmandateInfoPage, { iconSrc: icon, title: title, description: description, subDescription: subDescription }),
                React.createElement("div", { className: "w-100 px-2" },
                    React.createElement(GenericDetails, { details: genericDetails })),
                children && children)),
        genericDetailsCollapse && (React.createElement(React.Fragment, null,
            " ",
            React.createElement("div", { className: "DMSans_13_400  text-center order-status-screen-bottom mgt-30 d-flex align-items-center justify-content-center gap-1", onClick: handleDivOnClickShowMandateDetails },
                React.createElement("span", { className: "DMSans_13_400 " }, "Order Details"),
                React.createElement("div", { className: "d-flex align-items-center" },
                    React.createElement("span", { className: isCollapse
                            ? "edel-icon-arrow-up-thin"
                            : "edel-icon-arrow-down" }))),
            isCollapse && (React.createElement("div", { className: "w-100 px-2 bg_ghost-white3" },
                React.createElement(GenericDetails, { details: genericDetailsCollapse })))))));
};
export default OrderStatusScreen;
